module.exports = __webpack_public_path__ + "img/global-line.37d8ebc7.svg";